import { useState } from 'react'
import { Link } from 'react-router-dom'
import { useDbReports } from '../../base/useDbReports'
import { format } from 'date-fns'

export function SearchInvoices() {
    const [searchCriteria, setSearchCriteria] = useState({
        invoiceId: '',
        deliveryName: '',
        date: '',
    })

    const { invoices, directInvoices } = useDbReports()

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target
        setSearchCriteria((prev) => ({ ...prev, [name]: value }))
    }

    const filteredInvoices = [...invoices].filter((invoice) => {
        const invoiceDate = invoice.invoiceDate
            ? format(new Date(Number(invoice.invoiceDate)), 'yyyy-MM-dd')
            : ''
        const matchesInvoiceId = searchCriteria.invoiceId
            ? invoice.invoiceId?.toLowerCase().includes(searchCriteria.invoiceId.toLowerCase())
            : true
        const matchesCustomer = searchCriteria.deliveryName
            ? invoice.deliveryName?.toLowerCase().includes(searchCriteria.deliveryName.toLowerCase())
            : true
        const matchesDate = searchCriteria.date ? invoiceDate === searchCriteria.date : true

        return matchesInvoiceId && matchesCustomer && matchesDate
    })

    return (
        <div className="container mx-auto px-4 py-6">
            <h1 className="text-2xl font-bold mb-6">Search Invoices</h1>

            {/* Search Form */}
            <div className="bg-gray-50 p-6 rounded-lg shadow-md mb-6">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Invoice ID</label>
                        <input
                            type="text"
                            name="invoiceId"
                            value={searchCriteria.invoiceId}
                            onChange={handleInputChange}
                            className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Invoice ID"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Customer Name</label>
                        <input
                            type="text"
                            name="deliveryName"
                            value={searchCriteria.deliveryName}
                            onChange={handleInputChange}
                            className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                            placeholder="Enter Customer Name"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-medium text-gray-700">Date</label>
                        <input
                            type="date"
                            name="date"
                            value={searchCriteria.date}
                            onChange={handleInputChange}
                            className="mt-1 p-2 w-full border rounded-md focus:ring-blue-500 focus:border-blue-500"
                        />
                    </div>
                </div>
            </div>

            {/* Search Results */}
            <div className="mt-6">
                <h2 className="text-xl font-semibold mb-4">Search Results</h2>
                {filteredInvoices.length === 0 ? (
                    <div className="text-center text-gray-500 text-lg">No invoices found.</div>
                ) : (
                    <table className="table-auto w-full border-collapse border border-gray-300">
                        <thead>
                            <tr className="bg-gray-100 text-left">
                                <th className="py-2 px-4 border-b">Invoice ID</th>
                                <th className="py-2 px-4 border-b">Customer Name</th>
                                <th className="py-2 px-4 border-b">Date</th>
                                <th className="py-2 px-4 border-b">Type</th>
                                <th className="py-2 px-4 border-b text-right">Total Amount</th>
                                <th className="py-2 px-4 border-b text-right">Tax</th>
                            </tr>
                        </thead>
                        <tbody>
                            {filteredInvoices.map((invoice) => (
                                <tr key={invoice.invoiceId} className="border-b hover:bg-gray-50">
                                    <td className="py-2 px-4">
                                        <Link
                                            to={`/invoices/${invoice.invoiceId}`}
                                            className="text-blue-500 hover:underline"
                                        >
                                            {invoice.invoiceId}
                                        </Link>
                                    </td>
                                    <td className="py-2 px-4">{invoice.deliveryName || 'N/A'}</td>
                                    <td className="py-2 px-4">
                                        {invoice.invoiceDate
                                            ? format(new Date(Number(invoice.invoiceDate)), 'PP')
                                            : 'N/A'}
                                    </td>
                                    <td className="py-2 px-4">
                                        {'orderId' in invoice ? 'Online' : 'Direct'}
                                    </td>
                                    <td className="py-2 px-4 text-right">
                                        {new Intl.NumberFormat('ja-JP', {
                                            style: 'currency',
                                            currency: 'JPY',
                                        }).format(invoice.totalAmount)}
                                    </td>
                                    <td className="py-2 px-4 text-right">
                                        {new Intl.NumberFormat('ja-JP', {
                                            style: 'currency',
                                            currency: 'JPY',
                                        }).format(invoice.taxAmount)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </div>
        </div>
    )
}
